import { normalizeValue } from "./utils";
import { isRailShipmentInTrackArea } from "./locationUtils";

/**
 * Normalize a railcar (or similar) identifier for comparison.
 * Delegates to {@link normalizeValue}: uppercase alphanumeric only.
 */
export const normalizeRailCarNumber = (value) => normalizeValue(value);

/**
 * Compare identifiers after {@link normalizeValue} (same as {@link normalizeRailCarNumber}).
 * Non-empty expected after normalize is required for a match.
 */
export const isNormalizedIdentifierMatch = (
  expectedIdentifier,
  enteredIdentifier,
) => {
  const expected = normalizeRailCarNumber(expectedIdentifier);
  const entered = normalizeRailCarNumber(enteredIdentifier);

  return Boolean(expected) && entered === expected;
};

/** Railcar UI: alias of {@link isNormalizedIdentifierMatch}. */
export const isRailCarNumberMatch = isNormalizedIdentifierMatch;

export const getInboundRailcarVerificationState = ({
  isRailShipmentInTrackArea,
  verificationEnabled,
  railCarNumber,
  isRailcarValidated = false,
}) => {
  const requiresVerification =
    isRailShipmentInTrackArea &&
    verificationEnabled === true &&
    Boolean(normalizeRailCarNumber(railCarNumber));

  return {
    expectedRailCarNumber: railCarNumber || "",
    requiresVerification,
    isRailcarValidated: requiresVerification ? isRailcarValidated : false,
  };
};

export const getArrivingRailcarVerificationState = ({
  currentShipment,
  isRailcarValidated = false,
}) =>
  getInboundRailcarVerificationState({
    isRailShipmentInTrackArea: isRailShipmentInTrackArea(
      currentShipment?.areaId,
      currentShipment,
    ),
    verificationEnabled: currentShipment?.account?.verifyOutboundRailCar,
    railCarNumber: currentShipment?.railCarNumber,
    isRailcarValidated,
  });

export const getInboundRailcarVerificationResetKey = ({
  shipmentId,
  areaId,
  verificationEnabled,
  railCarNumber,
}) =>
  [
    shipmentId || "",
    areaId || "",
    verificationEnabled === true ? "true" : "false",
    normalizeRailCarNumber(railCarNumber),
  ].join("|");

export const getArrivingRailcarVerificationResetKey = ({
  currentShipment,
}) =>
  getInboundRailcarVerificationResetKey({
    shipmentId: currentShipment?.id,
    areaId: currentShipment?.areaId,
    verificationEnabled: currentShipment?.account?.verifyOutboundRailCar,
    railCarNumber: currentShipment?.railCarNumber,
  });

export const shouldBlockAcceptForRailcarVerification = ({
  isAcceptAction,
  requiresVerification,
  isRailcarValidated,
}) =>
  Boolean(isAcceptAction && requiresVerification && !isRailcarValidated);

export const shouldBlockSealActionForRailcarVerification = ({
  requiresVerification,
  isRailcarValidated,
}) => Boolean(requiresVerification && !isRailcarValidated);
